module.exports = __webpack_public_path__ + "media/src/images/testimonials/06-8fbcc2a7e736ab8f11a03528d9cbc008.jpg";